import { get } from "svelte/store"
import { kirbyApiPassword, kirbyApiUsername, kirbyUrl } from "../../../../api/hooks/config-client"
import { lang } from "../../store"
import { obj2str } from "../../../../api/hooks/lib/utils"
function recursivelyParseJSON(obj: any): any {
    if (typeof obj === "string") {
        try {
            return recursivelyParseJSON(JSON.parse(obj))
        } catch {
            return obj
        }
    } else if (Array.isArray(obj)) {
        return obj.map((item) => recursivelyParseJSON(item))
    } else if (typeof obj === "object" && obj !== null) {
        return Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, recursivelyParseJSON(value)]))
    }
    return obj
}
function btoa(str) {
    // Zeichen für Base64-Encoding
    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
    var encoded = ""
    var c = 0

    while (c < str.length) {
        var c1 = str.charCodeAt(c++)
        var c2 = str.charCodeAt(c++)
        var c3 = str.charCodeAt(c++)

        var e1 = c1 >> 2
        var e2 = ((c1 & 3) << 4) | (c2 >> 4)
        var e3 = ((c2 & 15) << 2) | (c3 >> 6)
        var e4 = c3 & 63

        if (isNaN(c2)) {
            e3 = e4 = 64
        } else if (isNaN(c3)) {
            e4 = 64
        }

        encoded += chars.charAt(e1) + chars.charAt(e2) + chars.charAt(e3) + chars.charAt(e4)
    }

    return encoded
}

function createKirbyRequest(options: KirbyFetchOptions) {
    const apiUrl = `${kirbyUrl}api/query`
    const username = kirbyApiUsername
    const password = kirbyApiPassword
    const language = options.language || get(lang) || (apiUrl.includes("/de") ? "de" : "en")

    const headers = {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Language": String(language),
    }

    const body: any = {
        query: options.query,
    }

    if (options.select) body.select = options.select
    if (options.sort) body.sort = options.sort
    if (options.limit) {
        body.pagination = {
            limit: options.limit,
            page: options.offset ? Math.floor(options.offset / options.limit) + 1 : 1,
        }
    }

    // Authorization aus dem Cache-Key ausschließen – der Key landet im HTML als __SSR_CACHE__
    const { Authorization, ...cacheHeaders } = headers
    const cacheKey = obj2str({ endpoint: apiUrl, options: body, headers: cacheHeaders })

    return {
        apiUrl,
        headers,
        body,
        cacheKey,
    }
}

export async function kirbyFetch<T>(options: KirbyFetchOptions): Promise<T | null> {
    const { apiUrl, headers, body, cacheKey } = createKirbyRequest(options)
    if (typeof window !== "undefined" && window.__SSR_CACHE__ && !location.pathname.includes("profile")) {
        const cache = window.__SSR_CACHE__[cacheKey]
        if (cache) return recursivelyParseJSON(cache.body.result)
    }

    if (typeof window === "undefined") {
        // server-side
        try {
            const data: KQLResponse<T> = context.ssrRequestKirby(cacheKey, apiUrl, "", {
                method: "POST",
                headers: headers,
                body: JSON.stringify(body),
            }).body
            return recursivelyParseJSON(data.result)
        } catch (e) {
            console.log(JSON.stringify(e))
            return Promise.reject(e)
        }
    } else {
        try {
            const header = new Headers(headers)
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: header,
                body: JSON.stringify(body),
            })

            if (!response.ok) throw new Error(`HTTP-Fehler! Status: ${response.status}`)
            const data: KQLResponse<T> = await response.json()

            return recursivelyParseJSON(data.result)
        } catch (error) {
            console.error("Fehler beim Abrufen der Daten:", error)
            return null
        }
    }
}

export async function getKirbyPage<T = "home">(slug: string, select?: any): Promise<KirbyPage<T>> {
    return kirbyFetch<KirbyPage<T>>({
        query: `page("${slug}")`,
        select,
    })
}

let fileCache: {
    [key: string]: FileData
} = {}

export async function getKirbyFile(id: string): Promise<FileData> {
    const match = id.match(/(['"])file:\/\/([\w-]+)\1/)
    const fileId = match ? match[2] : id
    if (fileCache[fileId]) return Promise.resolve(fileCache[fileId])
    const file = await kirbyFetch<FileData>({
        query: `file("file://${fileId}")`,
    })
    fileCache[fileId] = file
    return file
}
